// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6931 ? "d7c72f5b" : chunkId) + "." + {"1886":"1564ad0111db328f","4349":"4b6fce7247c3e90a","6931":"fd57739b3a1045ed"}[chunkId] + ".js";
};